import { Typography, Paper, Box, List, ListItem, ListItemText, Divider } from '@mui/material';

const SoundTransit = () => {
  const newFirms = [
    'Akana',
    'Atlas Technical Consultants, LLC',
    'Confluence Environmental Company',
    'Cordoba Corporation',
    'Haley & Aldrich',
    'RSI Remediation, LLC',
    'Stell Environmental Enterprises, Inc.',
    'TRC Environmental Corporation',
  ];

  return (
    <Box sx={{ maxWidth: 800, margin: '0 auto' }}>
      <Typography variant="h4" gutterBottom sx={{ color: 'primary.main', fontWeight: 'bold' }}>
        Sound Transit
      </Typography>
      <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
        <Typography variant="body1" paragraph>
          Sound Transit's Multiple Award Task Order Contract (MATOC) program is explicitly designed to build capacity and encourage participation from new firms, resulting in several prime contractors working with the agency for the first time or stepping up from previous subconsultant roles.
        </Typography>
        <Typography variant="body1" paragraph>
          While the provided documents do not explicitly name every single new prime contractor across all three MATOC disciplines, they do specifically identify the following firms as "New to ST" or "New primes" within the Environmental MATOC bench:
        </Typography>
        
        <Box sx={{ bgcolor: 'background.default', p: 2, borderRadius: 1, mb: 3 }}>
          <List dense>
            {newFirms.map((firm) => (
              <ListItem key={firm}>
                <ListItemText primary={firm} />
              </ListItem>
            ))}
          </List>
        </Box>

        <Typography variant="body2" color="text.secondary" paragraph sx={{ fontStyle: 'italic' }}>
          (Note: In total, the Environmental MATOC includes 5 primes entirely new to Sound Transit and 3 primes that had previously only served as subconsultants.)
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Typography variant="h6" gutterBottom>
          Other MATOC Benches
        </Typography>
        <Typography variant="body1" paragraph>
          For the other two MATOC benches, the sources provide the total count of new prime contractors but do not list them by name:
        </Typography>
        
        <List>
          <ListItem>
            <ListItemText 
              primary="Design MATOC" 
              secondary="Features 3 prime contractors entirely new to Sound Transit and 3 primes that previously worked as subconsultants." 
            />
          </ListItem>
          <ListItem>
            <ListItemText 
              primary="Project Management/Construction Management (PM/CM) MATOC" 
              secondary="Features 10 prime contractors entirely new to Sound Transit and 3 primes that previously worked as subconsultants." 
            />
          </ListItem>
        </List>

        <Typography variant="body1" sx={{ mt: 2, fontWeight: 'bold' }}>
          Altogether, across the three MATOCs, Sound Transit has successfully elevated 10 firms from subconsultants to prime contractor status, demonstrating a significant push for regional capacity building.
        </Typography>
      </Paper>
    </Box>
  );
};

export default SoundTransit;
